import { render, staticRenderFns } from "./housesList.vue?vue&type=template&id=4dd1773e&scoped=true&"
import script from "./housesList.vue?vue&type=script&lang=js&"
export * from "./housesList.vue?vue&type=script&lang=js&"
import style0 from "./housesList.vue?vue&type=style&index=0&id=4dd1773e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1773e",
  null
  
)

export default component.exports